import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import styles from 'aurora-components/Header/header-jss.js';

import { keyEmptyCheck } from 'aurora-utils/utils';
import { LightTooltipComponent } from 'aurora-components';
import { LanguageOutlined } from '@material-ui/icons';

const useStyles = makeStyles({
  iconBtn: {
    maxWidth: '40px',
    maxHeight: '40px',
    minWidth: '40px',
    minHeight: '40px',
    padding: '10px',
    marginLeft: '8px',
    '@media (max-width: 600px)': {
      maxWidth: '32px',
      maxHeight: '32px',
      minWidth: '32px',
      minHeight: '32px',
      padding: '10px',
      marginLeft: '0px',
      borderRadius: '5px',
      border: 'none',
    },
  },
});
function Toggle(props) {
  // const { message, intl, onToggle } = props;
  // eslint-disable-next-line no-unused-vars, react/prop-types
  const classes = useStyles();
  const { onToggle, type } = props;
  const handleChange = event => {
    event.preventDefault();
    onToggle(event);
  };

  return (
    <span onClick={handleChange} aria-hidden='true'>
      <LightTooltipComponent
        title={localStorage.getItem('lang') === 'ar' ? keyEmptyCheck('english') : keyEmptyCheck('arabic')}
      >
        <Button variant='outlined' className={classes.iconBtn}>
          <LanguageOutlined
            style={type === 'mobile' ? { width: '20px', height: '20px' } : { width: '24px', height: '24px' }}
          />
        </Button>
      </LightTooltipComponent>

      {/* {message === 'ar' ? intl.formatMessage(messages.english) : intl.formatMessage(messages.arabic)} */}
    </span>
  );
}

Toggle.propTypes = {
  onToggle: PropTypes.func.isRequired,
  // intl: intlShape.isRequired,
  type: PropTypes.string.isRequired,
};

export default withStyles(styles)(injectIntl(Toggle));
